import { FormRule } from "antd";
import { ZUid } from "src/types/zUid";
import { fKey } from "./delayedNotifyUtils";

export const anyReceiverRule =
  (path: (number | string)[]): FormRule =>
  ({ getFieldValue }) => ({
    validator: () => {
      const roleIds: ZUid[] | null | undefined = getFieldValue([
        ...path,
        fKey("roleIds"),
      ]);
      const receiverAttrIds: ZUid[] | null | undefined = getFieldValue([
        ...path,
        fKey("receiverAttrIds"),
      ]);
      const departmentAttrId: ZUid | null | undefined = getFieldValue([
        ...path,
        fKey("departmentAttrId"),
      ]);
      return roleIds?.length || receiverAttrIds?.length || departmentAttrId
        ? Promise.resolve()
        : Promise.reject(
            Error("Пожалуйста, укажите Роли, Адресата или Подразделение"),
          );
    },
  });
